import { combineReducers } from 'redux';
import { offers } from './offers';
import { ui } from './ui';
import { filters } from './filters';

export const Offers = combineReducers({
  offers,
  ui,
  filters,
});
